import { LOCALES } from 'fractals'

export const TITLE = {
  [LOCALES.en]: 'What professions can you work as',
  [LOCALES.ru]: 'Кем вы сможете работать',
  [LOCALES.uz]: 'Qaysi kasblarda ishlay olasiz',
  [LOCALES.kk]: 'Қандай қызметкерлердің қызметінде жұмыс істеуіңізге болады'
}
